import {
  CreateContactInvitationRequest,
  CreateContactInvitationResponse,
  CreateLinkInvitationRequest,
  CreateLinkInvitationResponse,
  CreateMembershipRequest,
  Membership,
} from '@/types/api/membership';
import { authenticatedClient } from '@/utils/shared/axios';

export default {
  get: async ({
    userId,
    groupId,
    include,
    saleId,
  }: {
    userId: string;
    groupId: string;
    include?: string[];
    saleId?: string;
  }) => {
    const response = await authenticatedClient.get<Membership>(`/memberships/${userId}:${groupId}`, {
      params: { include, saleId },
    });
    return response.data;
  },

  list: async (params: { userId?: string; groupId?: string; include?: string[]; saleId?: string }) => {
    const response = await authenticatedClient.get<Membership[]>(`/memberships`, { params });
    return response.data;
  },

  listByGroup: async () => {
    const response = await authenticatedClient.get<Membership[]>(`/memberships?groupId=context`);
    return response.data;
  },

  listByUser: async () => {
    const response = await authenticatedClient.get<Membership[]>(`/memberships/me`);
    return response.data;
  },

  current: async () => {
    const response = await authenticatedClient.get<Membership>(`/memberships/current`);
    return response.data;
  },

  create: async (data: CreateMembershipRequest) => {
    const response = await authenticatedClient.post<void>(`/memberships`, data);
    return response.data;
  },

  revoke: async (id: string) => {
    const response = await authenticatedClient.post<void>(`/memberships/${id}/revoke`);
    return response.data;
  },

  resign: async (id: string) => {
    const response = await authenticatedClient.post<void>(`/memberships/${id}/resign`);
    return response.data;
  },

  invitation: {
    createLink: async (data: CreateLinkInvitationRequest): Promise<CreateLinkInvitationResponse> => {
      const response = await authenticatedClient.post<CreateLinkInvitationResponse>(
        `/memberships/invitations/link`,
        data,
      );
      return response.data;
    },
    createContact: async (data: CreateContactInvitationRequest) => {
      const response = await authenticatedClient.post<CreateContactInvitationResponse>(
        `/memberships/invitations/contact`,
        data,
      );
      return response.data;
    },
  },
};
